import { render, staticRenderFns } from "./MyTeamActivities.vue?vue&type=template&id=163cd941&"
import script from "./MyTeamActivities.vue?vue&type=script&lang=js&"
export * from "./MyTeamActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports